import styles from "./styles.module.scss";
import { useUrls } from "@/hooks/useUrls";

interface FooterCTAProps {
  pageSlug: keyof ReturnType<typeof useUrls>;
}

export function FooterCTA({ pageSlug }: FooterCTAProps) {
  const urls = useUrls();
  const cta = urls[pageSlug];

  return (
    <div className={styles.container}>
      <a
        className={styles.link}
        href={cta.url}
        data-layer-event-prefix="Navigation Link"
        data-layer-action="click"
        data-layer-text={cta.title}
        data-layer-region="next visualization"
      >
        <div className={styles["image-wrap"]}>
          <img
            className={styles.img}
            src={cta.thumbnailLight}
            alt={cta.title}
          />
        </div>

        <div className={styles["text-wrap"]}>
          <h3 className={styles.overline}>Next visualization</h3>
          <h2 className={styles.headline}>{cta.headline}</h2>
          <p className={styles.title}>{cta.title}</p>
        </div>
      </a>
    </div>
  );
}
